// @flow

import CookieManager from "@cabonline/cookies"
import { autobind } from "core-decorators"
import { action, autorun, observable } from "mobx"
import type { AppType } from "shared/types/AppType"
import type { RedirectType } from "shared/types/RedirectType"

const uiCookie = {
  name: "cabonline.admin.ui",
  expirationDays: 365
}

type GlobalFleetSettings = {
  showSelector: boolean,
  selectedId: ?number
}
type GlobalSearchSettings = {
  showSearch: boolean,
  value: ?string
}

@autobind
class UiStore {
  @observable redirectTo: ?RedirectType
  @observable activeApp: AppType
  @observable activeSubApp: ?AppType = null
  @observable dashboardMenuHidden: boolean = true
  @observable version: string = ""
  @observable IntelLanguage: string = "sv" // Default to Swedish
  @observable
  fleet: GlobalFleetSettings = {
    showSelector: false,
    selectedId: null
  }
  @observable
  search: GlobalSearchSettings = {
    showSearch: false,
    value: null
  }

  _loadSettings() {
    const cookieData = CookieManager.get(uiCookie.name)

    if (cookieData && cookieData.selectedFleetId) {
      this.fleet.selectedId = cookieData.selectedFleetId
    }

    if (cookieData && cookieData.intlLanguage) {
      this.IntelLanguage = cookieData.intlLanguage
    }
  }

  @action
  setIntlLanguage(lang: string) {
    this.IntelLanguage = lang
  }

  @action
  setSelectedFleet(id: number) {
    this.fleet.selectedId = id
  }

  @action
  setSearchValue(value: string) {
    this.search.value = value
  }

  constructor() {
    this._loadSettings()
    autorun(() => {
      CookieManager.set({
        name: uiCookie.name,
        value: {
          selectedFleetId: this.fleet.selectedId,
          intlLanguage: this.IntelLanguage
        },
        expires: uiCookie.expirationDays
      })
    })
  }
}

export default (new UiStore(): any)
